export const SearchBar = {
  extends: ['DropdownParentFocus'],
  position: 'relative',
  theme: 'quinary',
  round: 'C',
  minWidth: 'D3',
  margin: '-V - - -',
  tag: 'search',
  state: {
    recents: []
  },
  Input_trigger: null,
  Form: {
    flow: 'x',
    align: 'center',
    gap: 'X',
    onSubmit: (ev) => ev.preventDefault(),
    Icon: {
      fontSize: 'Z1',
      margin: '- -B2 - A',
      name: 'search'
    },
    Input: {
      autofocus: 'autofocus',
      round: '0',
      placeholder: 'Search on Canvas',
      padding: 'Y1 B2 Y1 C',
      theme: 'transparent',
      outline: 'none',
      appearance: 'none',
      ':focus-visible': {
        outline: 'none'
      },
      '::-webkit-search-cancel-button': {
        display: 'none'
      },
      '::placeholder': {
        color: 'placeholder'
      },
      onInput: (ev, el, s) => {
        s.update({
          searchTerm: el.node.value
        })
      },
      flex: 1
    }
  },
  Dropdown: {
    top: '105%',
    width: '100%',
    left: '0',
    extends: ['CanvasSearchDropdown', 'Dropdown']
  }
}
